const initAnnouncementGroup = (announcements: Element) => {
  const timing = announcements?.getAttribute('data-timing') || 5;
  const timingMs = +timing * 1000;
  createTimedAnnouncement(announcements?.children, timingMs);
}

const createTimedAnnouncement = (announcements: HTMLCollection, timingMs) => {
  const currentIndex = Array.from(announcements).findIndex((an) => an.classList.contains('active'));

  if(currentIndex === -1) announcements[0].classList.add('active');
  if(announcements.length === 1) return;

  setTimeout(() => {
    if(currentIndex !== -1) {
      announcements[currentIndex].classList.remove('active');

      if(currentIndex === announcements.length - 1) {
        announcements[0].classList.add('active');
      } else {
        announcements[currentIndex + 1].classList.add('active');
      }
    }
    createTimedAnnouncement(announcements, timingMs);
  }, timingMs)
}

const runSlides = () => {
  let allAnnouncements: NodeListOf<Element> = document.querySelectorAll('[data-action="announcement-carousel"]');

  if(allAnnouncements.length === 1) {
    initAnnouncementGroup(allAnnouncements[0]);
  }
  else {
    for (const an of allAnnouncements) {
      initAnnouncementGroup(an)
    }
  }
}

export const loadedAnnouncements = window.addEventListener('load', runSlides);
